import React, { MouseEvent, useState, useCallback, memo } from 'react';
import { Box, Button, Divider, Grid, Menu, MenuItem, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { ModalConfirmacao } from '..';
import { GetAuthLoginRedirect } from 'utils';
import { useStyles } from './cardapio-menu-conta-styles';
import { EmpresaModel } from 'api/cardapio/models/empresa/empresa-model';
import { useThemeQueries } from 'components/dialogs/dialog-adicionar-produto-com-subitem/util-styles';
import { EnumDialogs, useDialogStore } from 'services/store/dialog-store';
import { SairIcon } from 'components/icons/sair-icon';
import { PerfilIcon } from 'components/icons/perfil-icon';
import { useConfirm } from 'material-ui-confirm';
import { MeusPedidosDesktopIcon } from 'utils/Icons/meus-pedidos-icon-desktop';
import { EnumModals, useModalStore } from 'services/store/modal-store';
import { useObterToken } from 'services/store/obter-token';
import { usePessoaUsuarioStore } from 'services/store/pessoa-usuario';
import { VariaveisAmbiente } from 'ambiente';
import { EnumDeviceType } from 'ambiente/ambiente-tipos';

export interface CardapioMenuContaProps {
  logout: () => any;
  setCarregando: (carregando) => any;
  nomeUsuario?: string;
  adminLogado: boolean;
  tema: any;
  empresa: EmpresaModel;
}

export const CardapioMenuConta = ({
  logout,
  setCarregando,
  nomeUsuario,
  adminLogado,
  tema,
  empresa,
}: CardapioMenuContaProps) => {
  const classes = useStyles();
  const [anchorMenu, setAnchorMenu] = useState<null | HTMLElement>(null);
  const [modal, setModal] = useState(false);
  const { isMobile } = useThemeQueries();
  const { openCloseDialog } = useDialogStore()
  const { openCloseModal } = useModalStore()
  const { pessoa } = usePessoaUsuarioStore()
  const confirm = useConfirm()
  const token = useObterToken(state => state.token)
  const isCordova = VariaveisAmbiente.deviceType === EnumDeviceType.CORDOVA

  const handleMenu = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      setAnchorMenu(event.currentTarget);
    },
    [setAnchorMenu]);

  const handleClose = useCallback(() => {
    setAnchorMenu(null);
  }, [setAnchorMenu]);

  const handleCloseWrapper = useCallback(
    (funcao, carregando?: boolean) => {
      handleClose();
      if (carregando) {
        setCarregando(carregando || false);
        carregando ? setTimeout(() => funcao(), 1) : funcao();
        window.location.assign(GetAuthLoginRedirect())
      }
      if (!carregando) {
        setCarregando(carregando || false);
        carregando ? setTimeout(() => funcao(), 1) : funcao();
      }
    },
    [handleClose, setCarregando],
  );

  const handleModal = useCallback(() => {
    setModal((prev) => !prev);
  }, []);

  const deslogar = () => {
    confirm({
      title: 'Confirmação',
      description: 'Deseja realmente deslogar?',
      confirmationText: 'Confirmar',
      confirmationButtonProps: {
        color: 'primary',
        variant: 'contained',
      }
    }).then(() => {
      handleCloseWrapper(logout, false);
    })
  }

  return (
    <>
      <Grid item style={{
        display: 'flex',
        justifyContent: 'flex-end',
      }}>
        <Button
          aria-haspopup="true"
          onClick={(e) => !token ? openCloseDialog(isCordova ? EnumDialogs.Autenticar : EnumDialogs.AutenticarCliente, true) : handleMenu(e)}
          color="primary"
          variant="contained"
          className={classes.perfilButton}
        >
          <PerfilIcon tipo="BUTTON_PRIMARY" class={classes.perfilIcon} />
          {!isMobile && (
            <>
              {!token ? 'Entrar' : adminLogado ? 'Administrador' : ((pessoa?.nome?.split(' ')[0]) || 'Perfil')}
            </>
          )}
        </Button>
      </Grid>

      {anchorMenu ? (
        <>
          <Menu
            anchorEl={anchorMenu}
            keepMounted
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 40, horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={Boolean(anchorMenu)}
            onClose={handleClose}
          >
            {(
              (token && (
                <>
                  <MenuItem onClick={() => handleCloseWrapper(() => openCloseDialog(EnumDialogs.Perfil, true))}>
                    <Typography
                      className={classNames(classes.btnMenu, classes.pointer)}
                      color="textPrimary"
                    >
                      <PerfilIcon tipo="BUTTON" />
                      Meus dados
                    </Typography>
                  </MenuItem>
                  {!adminLogado && (
                    <MenuItem onClick={() => handleCloseWrapper(() => openCloseModal(EnumModals.HistoricoPedidos, true))}>
                      <Typography
                        className={classNames(classes.btnMenu, classes.pointer)}
                        color="textPrimary"
                      >
                        <MeusPedidosDesktopIcon tipo="BUTTON" />
                        Histórico de Pedidos
                      </Typography>
                    </MenuItem>
                  )}
                  <Box py={1}>
                    <Divider />
                  </Box>
                  <MenuItem onClick={() => deslogar()}>
                    <Typography
                      className={classNames(classes.btnMenu, classes.pointer)}
                      color="textPrimary"
                    >
                      <SairIcon tipo="BUTTON" />
                      Sair da Conta
                    </Typography>
                  </MenuItem>
                </>
              ))
            )}

          </Menu>

          <ModalConfirmacao
            aberto={modal}
            quandoLogar={logout}
            quandoCancelar={handleModal}
          />
        </>
      ) : ''}
    </>
  );
};

export const MenuConta = memo(CardapioMenuConta);
